import { render, staticRenderFns } from "./UnidadeComparacaoRotas.vue?vue&type=template&id=4550a47c&scoped=true&"
import script from "./UnidadeComparacaoRotas.vue?vue&type=script&lang=js&"
export * from "./UnidadeComparacaoRotas.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeComparacaoRotas.vue?vue&type=style&index=0&id=4550a47c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4550a47c",
  null
  
)

export default component.exports